import { IoMdCheckmark } from "react-icons/io";
import "./AlarmActions.css";
import React, { useState } from "react";
import ModalComponent from "../Modal/ModalComponent";
import Select from "../Select/Select";
import TextAreaInput from "../TextAreaInput/TextAreaInput";
import EventsService from "../../services/EventsService";
import { createDateFromFormat, formatDate } from "../../utils/date";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { getEventData } from "../../constants/events";
import { DatetimeWithRelative } from "../DatetimeWithRelative/DatetimeWithRelative";

export const AlarmResults = [
	{ value: "ignored", text: "monitoring.ignoredAlarm" },
	{ value: "reported", text: "monitoring.reportedAlarm" },
	{ value: "solved", text: "monitoring.solvedAlarm" },
];

export function getAlarmResultText(alarmResult) {
	return AlarmResults.find(result => alarmResult === result.value)?.text;
}

export const AlarmActions = ({ alarm, unit }) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [alarmConfirmation, setAlarmConfirmation] = useState(false);
	const [alarmAction, setAlarmAction] = useState("");
	const [alarmResult, setAlarmResult] = useState("");
	const { t } = useTranslation();

	const alarmData = getEventData(alarm.name);

	function onFinishClick(alarm) {
		setModalIsOpen(true);
	}

	const handleConfirm = async (modalType) => {
		if (modalType === "finish") {
			const alarm = buildPayload();
			const response = await EventsService.updateEvent(alarm.id, alarm);
			setModalIsOpen(false);
			setAlarmConfirmation(false);
			setAlarmAction("");
			setAlarmResult("");
		}
	};
	const handleCancel = (modalType) => {
		if (modalType === "finish") {
			setModalIsOpen(false);
			setAlarmConfirmation(false);
			setAlarmAction("");
			setAlarmResult("");
		}
	};
	const buildPayload = () => {
		let { unit, unitId, ...alarmEventUpdated } = alarm;
		alarmEventUpdated.visible_on_monitoring = false;
		alarmEventUpdated.alarm_confirmation = alarmConfirmation != null ? alarmConfirmation === "true" : null;
		alarmEventUpdated.alarm_action = alarmAction;
		alarmEventUpdated.alarm_result = alarmResult;
		return alarmEventUpdated;
	};

	return (
		<>
			<Button
				label={t("common.finish")}
				icon={<IoMdCheckmark />}
				type="button"
				onClick={() => onFinishClick(alarm)}
			/>
			<ModalComponent
				modalIsOpen={modalIsOpen}
				modalText={`${t("monitoring.eventFinish")}:`}
				handleConfirm={() => handleConfirm("finish")}
				handleCancel={() => handleCancel("finish")}
			>
				<div style={{ display: 'flex', gap: '14px', width: '420px', flexDirection: 'column', marginTop: '20px' }}>
					<div className="alarm-details-box">
						<span>
							<span>{t("common.event")}:</span>{" "}
							<span className="flex flex-row items-center gap-1.5!">
								{alarmData?.icon ? React.createElement(alarmData.icon, { size: 16, className: 'opacity-40!' }) : null}
								<span className="font-semibold!">{t(alarmData?.name) || alarm.name}</span>
							</span>
						</span>
						<span>
							<span>{t("common.location")}:</span>{" "}{alarm.target_sector && alarm.target_sector !== "" ? alarm.target_sector : (alarm.target_name ? (<span>{alarm.unit?.name ? alarm.unit.name + '/' : ''} {alarm.target_name}</span>) : (<small>{t("common.doesNotContain")}</small>))}
						</span>
						<span>
							<span>{t("common.user")}:</span>{" "}{alarm.user ? (<span>{alarm.user}</span>) : (<small>{t("common.doesNotContain")}</small>)}
						</span>
						<span>
							<span>{t("common.info")}:</span>{" "}{alarm.data ? (<span>{alarm.data}</span>) : (<small>{t("common.doesNotContain")}</small>)}
						</span>
						<span>
							<span>{t("common.date")}:</span>{" "}<span><DatetimeWithRelative datetime={alarm.fulldate} /></span>
						</span>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '14px' }}>
						<Select
							labelText={t("common.confirmation")}
							name="alarm_confirmation"
							id="alarm_confirmation"
							value={alarmConfirmation}
							onChange={({ target }) =>
								setAlarmConfirmation(target.value)
							}
							required={true}
							options={[
								{ value: 'true', text: t("monitoring.confirmedAlarm") },
								{ value: 'false', text: t("monitoring.falseAlarm") },
							]}
						/>
						<Select
							labelText={t("common.result")}
							name="alarm_result"
							id="alarm_result"
							value={alarmResult}
							onChange={({ target }) => setAlarmResult(target.value)}
							required={true}
							options={AlarmResults.map(result => ({ value: result.value, text: t(result.text) }))}
						/>
					</div>
					<TextAreaInput
						labelText={t("common.action")}
						name="alarm_action"
						id="alarm_action"
						type={"textfield"}
						value={alarmAction}
						onChange={({ target }) => setAlarmAction(target.value)}
						required={true}
					/>
				</div>
			</ModalComponent >
		</>
	);
}